import React from 'react';
import styles from './big-car-found.module.scss'
import Button from 'src/components/button/Button';
import { useHistory } from 'react-router-dom';

const BigCarConfirmation: React.FunctionComponent = () => {
  const history = useHistory()

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p className={styles.title}>Tak for din bestilling</p>
        <p className={`${styles.text} tw-mb-3`}>Vi har reserveret en storvogn til dig! Du får besked, når chaufføren er på vej til dig :)</p>
      </div>
      <footer className={styles.footer}>
        <Button handleClick={() => history.goBack()} modifiers='tw-mx-auto' type='secondary' label='tilbake' />
      </footer>
    </div>
  )
}

export default BigCarConfirmation